import { useRouter } from "@/i18n/routing";
import { LogoutAction } from "@/lib/actions";
import { startTransition } from "react";

export default function useLogoutAction(callback?: () => void) {
  const router = useRouter();
  const performLogout = () => {
    startTransition(async () => {
      await LogoutAction();
      callback && callback();
      router.push("/");
    });
  };
  return performLogout;
}
